import React, { useState } from 'react'
import logo from '../assets/logo.png'
import Input from '../ui/forms/Input'
import Button from '../ui/comp/Button'
import { useMutation } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import { useNavigate } from 'react-router-dom'

function Login() {

    const [data, setdata] = useState({
        email: "",
        password: ""
    })

    const handleInput = (e) => {
        const { id, value } = e.target;
        setdata({ ...data, [id]: value })
    }

    const navigate = useNavigate()

    // Login Button
    const { mutate, isPending, error } = useMutation({
        mutationFn: async (formdata) => {
            return Axios.post('/auth/login', formdata)
        },
        onSuccess: (res) => {
            navigate(`/`)
        }
    })

    const handleLogin = () => {
        mutate(data)
    }

    return (
        <div className='w-full relative flex items-center justify-center p-5 h-screen'>
            <div className="bg-white max-w-xl w-full p-5 py-16 rounded-xl space-y-12 pb-24">

                {/* Logo */}
                <div className="flex items-center justify-center w-full">
                    <img src={logo} alt="" className='w-36' />
                </div>

                {/* Greeting Card */}
                <div className="w-full space-y-2">
                    <h1 className="text-center text-2xl font-bold text-green-700">Hi, Welcome Back</h1>
                    <p className="text-gray-500 text-center font-medium">Enter your credentials to continue</p>
                </div>

                {error && (
                    <p className="text-red-500 text-sm capitalize text-center">{error?.response?.data}</p>
                )}

                {/* Login details */}
                <div className='w-full px-5 md:px-16 space-y-5'>
                    <Input
                        value={data.email}
                        id='email'
                        onChange={handleInput}
                        placeHolder="Email"
                    />
                    <Input
                        value={data.password}
                        id='password'
                        onChange={handleInput}
                        placeHolder="Password"
                        type='password'
                    />
                    <Button
                        loading={isPending}
                        fullWidth={true}
                        onClick={handleLogin}
                    >
                        Sign In
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Login